import useMap from "../../../utils/useMap";
import useStoreChain from "./useStoreChain";

const store = useMap();

export const useQuerySubChain = (chainId) => {
    const subChainIds = store.get(chainId);
    if (!subChainIds) return;
    const subChains = [];
    subChainIds.forEach(subId => {
        const chain = useStoreChain(chainId);
        if (chain) {
            subChains.push(chain);
        }
    })
    return subChains;
}

export const storeSubChain = (chainId, subChainId) => {
    if (!store.has(chainId)) {
        store.set(chainId, new Set());
    }
    store.get(chainId).add(subChainId);
}

export const deleteSubChainByChainId = (chainId) => {
    const subChains = useQuerySubChain(chainId);
    store.delete(chainId);
    if (subChains) {
        while (subChains.length > 0) {
            const target = subChains.shift();
            target.discardChain();
        }
    }
}

export const deleteSubChain = (chainId, subChainId) => {
    if (!store.has(chainId)) return;
    store.get(chainId).delete(subChainId);
}